import axios from "axios";
import { TestConnection } from "./testConnection";
import { setTallyConfig } from "../helpers/constants";
import { toast } from "react-toastify";
import { GetBankAccounts, GetLedgers, GetSalesLedgers, GetTaxesLedgers } from "./ledger";
import { GetGroups } from "./groups";
import { GetStockItems } from "./items";
import { SyncLedgers } from "../sync/ledgers";
import { SyncStockItems } from "../sync/items";
import { GetGodowns } from "./godowns";
import { GetAccStatementOfParty, GetOutStandingOfAllParties, GetStockSummary } from "./reports";
import { SyncOutStandings } from "../sync/reports";
import { organisationSignal } from "../../../../signal/organisationSignal";
import { GetReceiptVoucherTypes, GetReceiptVouchers, GetSalesVoucherTypes, GetSalesVouchers } from "./vouchers";
import { SyncReceiptVouchers, SyncSalesVouchers } from "../sync/vouchers";
import { DEV_SERVER } from "../../../../constants/urls";
import * as moment from "moment";
import { userSignal } from "../../../../signal/userSignal";
import { GetCompanyList } from "./companyList";
import { getProducts } from "../../../../utilities/getProducts";
import { getDealers } from "../../../../utilities/getDealers";
import { GetLastAlterId } from "./lastAlterId";
import { dealerSignal } from "../../../../signal/dealerSignal";

export async function TallyInit(dispatch, fullUpdateSequence, sync) {

    dispatch({ type: "tallySync/increment" })

    let companies = organisationSignal?.value?.tallyConfig?.companies || []

    let temp = JSON.parse(JSON.stringify(companies))

    companies = temp

    if (companies.length === 0) {
        toast.error("No Company Found")
        dispatch({ type: "tallySync/decrement" })
        return;
    }
    setTallyConfig(companies[0])

    let testConnection = await TestConnection()

    if (!testConnection) {
        dispatch({ type: "tallySync/tallyNotReachable" })
        dispatch({ type: "tallySync/decrement" })
        return;
    } else {
        dispatch({ type: "tallySync/tallyReachable" })
    }

    let tallyCompanyList = await GetCompanyList()

    if (!tallyCompanyList) {
        toast.error("Error in fetching company list")
        dispatch({ type: "tallySync/decrement" })
        return;
    }

    tallyCompanyList = JSON.parse(window.localStorage.getItem("tally-company-list"))

    if (sync) {
        let connect = await window.electron.grpcConnect({
            startSync: true
        })
    }

    for (let k = 0; k < companies.length; k++) {

        if (!tallyCompanyList[companies[k].companyName]) {
            toast.error(companies[k].companyName + " Company not found in Tally")
            continue;
        }


        setTallyConfig(companies[k])

        let alterId = window.localStorage.getItem(`tally-${companies[k].companyName}-altId`)
        let voucherId = window.localStorage.getItem(`tally-${companies[k].companyName}-vchAltId`)

        if (alterId && voucherId) {
            alterId = parseInt(alterId)
            voucherId = parseInt(voucherId)

            let res = await GetLastAlterId()

            if (res && res.alterId === alterId && res.voucherId === voucherId) {
                console.log("alterId and voucherId matched")
                continue;
            }

            alterId = res.alterId
            voucherId = res.voucherId
        }

        let groups = await GetGroups(sync)

        if (!groups) {
            toast.error("Error in fetching groups")
            dispatch({ type: "tallySync/decrement" })
            return;
        }

        let promises = [GetSalesVoucherTypes(), GetReceiptVoucherTypes(), GetSalesLedgers(), GetTaxesLedgers(), GetGodowns(), GetBankAccounts()]

        let [salesVoucherTypes, receiptVoucherTypes, salesLedgers, taxesLedgers, godowns, bankAccounts] = await Promise.all(promises)

        if (!sync) {
            continue;
        }

        console.log("salesVoucherTypes completed")
        await GetLedgers()

        console.log("GetLedgers completed")
        let syncFromDate = companies[k].syncFromDate
        if (!syncFromDate) {
            syncFromDate = "2024/04/01"
        }
        let currentDate = moment().format("YYYY/MM/DD")

        let resp = await GetStockItems(syncFromDate, currentDate)

        console.log("GetStockItems completed")

        await GetOutStandingOfAllParties()

        console.log("GetOutStandingOfAllParties completed")

        await GetStockSummary()

        console.log("GetStockSummary completed")

        await Promise.all([getDealers(), getProducts()])


        console.log("getDealers and getProducts completed")

        // date intervals of two days
        let startDate = moment(syncFromDate)
        let endDate = moment(currentDate)
        let duration = moment.duration(endDate.diff(startDate))
        let days = duration.asDays()
        console.log("days", days)
        for (let i = 0; i <= days; i++) {
            let start = moment(syncFromDate).add(i, 'days').format("YYYY/MM/DD")

            let end = start
            if (moment(end) > moment(currentDate)) {
                end = currentDate
            }

            console.log("start ", start, "end ", end)
            await Promise.all([GetSalesVouchers(start, end), GetReceiptVouchers(start, end)])
        }

        console.log("GetSalesVouchers and GetReceiptVouchers completed")


        startDate = moment().subtract(3, 'months').startOf('month').format("YYYY/MM/DD")
        endDate = moment().format("YYYY/MM/DD")

        if(organisationSignal?.value?.name!=="Esquire Drug House" && dealerSignal.value){
            for (const key of Object.keys(dealerSignal.value)) {
                if(key && dealerSignal?.value[key]?.isTallyDealer===true){
                    for(let td=0; td<dealerSignal?.value[key]?.tallyDetails?.length; td++){
                        if(dealerSignal?.value[key]?.tallyDetails[td]?.companyName === companies[k].companyName){
                            await Promise.all([GetAccStatementOfParty(dealerSignal.value[key], startDate, endDate)])
                            break;
                        }
                    }
                    
                }
            }
        }

        console.log("Acc statements done")

        if (!alterId || !voucherId) {
            let res = await GetLastAlterId()

            alterId = res.alterId
            voucherId = res.voucherId
        }
        window.localStorage.setItem(`tally-${companies[k].companyName}-altId`, alterId)
        window.localStorage.setItem(`tally-${companies[k].companyName}-vchAltId`, voucherId)

    }

    if (fullUpdateSequence && fullUpdateSequence !== undefined && fullUpdateSequence !== null && fullUpdateSequence !== "") {
        window.localStorage.setItem("fullTallySynSeries", fullUpdateSequence)
    }

    dispatch({ type: "tallySync/decrement" })
    if (sync) {
        setTimeout(async () => {
            let disconnect = await window.electron.grpcConnect({
                endSync: true
            })
        }, 5000)
    }

}